// import { formatDate, parseDate, isDateObject, getWeekNumber } from 'element-ui/src/utils/date-util';
import YearRange from "./YearRange";
// 重写date-range组件
import DateRange from "./date-range.vue";
import {
  formatDate,
  isDateObject,
  prevMonth,
  nextMonth,
  nextYear,
  prevYear,
} from "element-ui/src/utils/date-util";

const HAVE_TRIGGER_TYPES = [
  "date",
  "datetime",
  "time",
  "time-select",
  "week",
  "month",
  "year",
  "daterange",
  "monthrange",
  "timerange",
  "datetimerange",
  "yearrange",
  "dates",
];
const DATE_FORMATTER = function (value, format) {
  if (format === "timestamp") return value.getTime();
  return formatDate(value, format);
};
const valueEquals = function (a, b) {
  // considers Date object and string
  const dateEquals = function (a, b) {
    const aIsDate = a instanceof Date;
    const bIsDate = b instanceof Date;
    if (aIsDate && bIsDate) {
      return a.getTime() === b.getTime();
    }
    if (!aIsDate && !bIsDate) {
      return a === b;
    }
    return false;
  };

  const aIsArray = a instanceof Array;
  const bIsArray = b instanceof Array;
  if (aIsArray && bIsArray) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, index) => dateEquals(item, b[index]));
  }
  if (!aIsArray && !bIsArray) {
    return dateEquals(a, b);
  }
  return false;
};
let DatePicker = window.ELEMENT.DatePicker;
let dateMixins = DatePicker.mixins[0];
DatePicker.watch = {
  type(type) {
    if (this.picker) {
      this.unmountPicker();
      this.mountPicker();
    }
  },
};
DatePicker.data = function () {
  return {
    panelRendered: false,
  };
};
DatePicker.methods = {
  handleFocus() {
    // 如果是其他项目组自行拓展date-picker组件，则不走平台逻辑
    if (!this.customType) {
      if (this.type === "yearrange") {
        this.panel = YearRange;
      } else if (this.type === "daterange" || this.type === "monthrange") {
        // 日期选择
        if (!this.panelRendered) {
          let isAddYear = false;
          let year;
          let _this = this;
          const selectionMode = this.type === "daterange" ? "month" : "year";
          // 处理组件为直接继承其他组件，且无render情况
          const render = this.panel.render ?? this.panel?.extends?.render;
          if (render) {
            // DateRange.i18n = this.$root.$i18n;
            this.panel.render = function (h) {
              let vNodes = render.call(this, h);
              if (!isAddYear) {
                // 创建年弹窗
                year = h(DateRange, {
                  props: {
                    date: new Date(),
                    format: _this.format,
                    pickerOptions: _this.pickerOptions,
                    selectionMode,
                  },
                  on: {
                    pick(val) {
                      if (year.componentInstance.pos === "left") {
                        _this.picker.leftDate = val;
                        if (!_this.picker.unlinkPanels) {
                          _this.picker.rightDate =
                            _this.type === "monthrange"
                              ? nextYear(val)
                              : nextMonth(val);
                        }
                      } else {
                        _this.picker.rightDate = val;
                        if (!_this.picker.unlinkPanels) {
                          _this.picker.leftDate =
                            _this.type === "monthrange"
                              ? prevYear(val)
                              : prevMonth(val);
                        }
                      }
                    },
                  },
                });
                vNodes?.componentOptions?.children[0]?.children[0]?.children[1]?.children?.push(
                  year
                );
              }
              this.$nextTick(() => {
                year.componentInstance.show = false;
                vNodes.elm.querySelector(
                  ".is-left .el-date-range-picker__header >div:last-child"
                ).onclick = () => {
                  year.componentInstance.pos = "left";
                  year.componentInstance.currentView = "year";
                  year.componentInstance.show = true;
                };
                vNodes.elm.querySelector(
                  ".is-right .el-date-range-picker__header >div:last-child"
                ).onclick = () => {
                  year.componentInstance.pos = "right";
                  year.componentInstance.currentView = "year";
                  year.componentInstance.show = true;
                };
              });
              return vNodes;
            };
          }
          this.panelRendered = true;
        }
      }
    }

    const type = this.type;
    if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
      this.pickerVisible = true;
    }
    this.$emit("focus", this);
    this.$emit("update:clearable", true);
  },
  handleRangeClick() {
    this.handleFocus();
  },
  emitInput(val) {
    let formatted;
    if (this.type == "yearrange") {
      const isFormattable =
        isDateObject(val) || (Array.isArray(val) && val.every(isDateObject));
      if (this.valueFormat && isFormattable) {
        formatted = [
          DATE_FORMATTER(val[0], this.valueFormat),
          DATE_FORMATTER(val[1], this.valueFormat),
        ];
      } else {
        formatted = val;
      }
    } else {
      formatted = this.formatToValue(val);
    }
    if (!valueEquals(this.value, formatted)) {
      this.$emit("input", formatted);
    }
  },
};

DatePicker.computed = {
  displayValue() {
    let displayValue = dateMixins.computed.displayValue;
    const values = displayValue.call(this);
    if (this.type === "yearrange" && this.parsedValue?.length > 0) {
      const parsedValue =
        typeof this.parsedValue === "string"
          ? this.parsedValue.split(",")
          : this.parsedValue;
      let before =
        parsedValue[0] === "" ? "" : new Date(parsedValue[0]).getFullYear();
      let after =
        parsedValue[0] === "" ? "" : new Date(parsedValue[1]).getFullYear();
      if (before && after && this.format) {
        let sdate = new Date(before, 0, 1, 0, 0, 0);
        let edate = new Date(after, 11, 31, 23, 59, 59);
        before = DATE_FORMATTER(sdate, this.format);
        after = DATE_FORMATTER(edate, this.format);
      }
      return [before, after];
    }
    return values;
  },
  haveTrigger() {
    if (typeof this.showTrigger !== "undefined") {
      return this.showTrigger;
    }
    return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
  },
};

DatePicker.mixins[0].mixins.push({
  watch: {
    pickerVisible(to) {
      this.$emit("visible-change", to);
    },
  },
});

const mountPicker = dateMixins.methods.mountPicker;

// 修复时间选择面板在中文模式下有格式错误问题
DatePicker.methods.mountPicker = function () {
  if (this?.panel?.computed?.timeFormat)
    this.panel.computed.timeFormat = function () {
      let format = "HH:mm:ss";
      if (this.format) {
        let timeFormat = extractFormat(this.format)?.time;
        if (timeFormat) format = timeFormat;
      }
      return format;
    };
  if (this?.panel?.computed?.dateFormat)
    this.panel.computed.dateFormat = function () {
      let format = "yyyy-MM-dd";
      if (this.format) {
        let dateFormat = extractFormat(this.format)?.date;
        if (dateFormat) format = dateFormat;
      }
      return format;
    };
  mountPicker.apply(this, arguments);
};

function extractFormat(format) {
  let oldFormat = format;
  const keywordRegs = [
    {
      type: "date",
      reg: /y{2,4}/,
    },
    {
      type: "date",
      reg: /M{1,2}/,
    },
    {
      type: "date",
      reg: /d{1,2}/,
    },
    // {
    //   type: "date",
    //   reg: /\./
    // },
    // {
    //   type: "date",
    //   reg: /\-/
    // },
    // {
    //   type: "date",
    //   reg: /\//
    // },
    // {
    //   type: "date",
    //   reg: /年/
    // },
    // {
    //   type: "date",
    //   reg: /月/
    // },
    // {
    //   type: "date",
    //   reg: /日/
    // },
    {
      type: "time",
      reg: /H{1,2}/,
    },
    {
      type: "time",
      reg: /h{1,2}/,
    },
    {
      type: "time",
      reg: /m{1,2}/,
    },
    {
      type: "time",
      reg: /s{1,2}/,
    },
    {
      type: "time",
      reg: /A/,
    },
    {
      type: "time",
      reg: /a/,
    },
    {
      type: "time",
      reg: /ZZ/,
    },
    // {
    //   type: "time",
    //   reg: /时/
    // },
    // {
    //   type: "time",
    //   reg: /分/
    // },
    // {
    //   type: "time",
    //   reg: /秒/
    // },
    // {
    //   type: "time",
    //   reg: /\:/
    // },
  ];
  const captions = [];
  while (format.length) {
    let match = null;
    keywordRegs.forEach(({ reg, type }) => {
      let mth = format.match(reg);
      if (mth) {
        if (!match || mth.index < match.index) {
          match = {
            type: type,
            index: mth.index,
            text: mth[0],
          };
        }
      }
    });
    if (match) {
      if (match.index > 0) {
        captions.push({
          type: "text",
          text: format.slice(0, match.index),
        });
      }
      captions.push({
        type: match.type,
        text: match.text,
      });
      format = format.slice(match.index + match.text.length);
    } else {
      captions.push({
        type: "text",
        text: format,
      });
      format = "";
    }
  }
  let dateRegs = [];
  let timeRegs = [];

  let oldCaption = null;
  while (captions.length) {
    let caption = captions.shift();
    if (caption.type == "text") {
      if (oldCaption?.type == "date") {
        dateRegs.push(caption);
      } else if (oldCaption?.type == "time") {
        timeRegs.push(caption);
      }
    } else if (caption.type == "date") {
      dateRegs.push(caption);
    } else if (caption.type == "time") {
      timeRegs.push(caption);
    }
    oldCaption = caption;
  }
  return {
    format: oldFormat,
    date: dateRegs
      .map(({ text }) => text)
      .join("")
      .trim(),
    time: timeRegs
      .map(({ text }) => text)
      .join("")
      .trim(),
  };
}
